var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"50px"},on:{"click":_vm.onClearStorage}})
}
var staticRenderFns = []

export { render, staticRenderFns }